import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { initGA, trackPageView } from './utils/analytics'; // Import analytics

// Components
import Homepage from './landing/pages/Homepage';
import Nav from './landing/components/Nav';
import 'bootstrap/dist/css/bootstrap.min.css';

// Landing Pages
import Aboutus from './landing/pages/Aboutus';
import Countingsection from './landing/pages/Countingsection';
import Gallery from './landing/pages/Gallery';
import Menu from "./landing/pages/Menu";
import Error404 from "./landing/pages/Error404";
import Contactusform from './landing/pages/contactusform';
import Grababitenow from './landing/pages/Grababitenow';
import Blog from './landing/pages/Blog';
import Terms from './landing/pages/terms';
import Privacypolicy from './landing/pages/privacypolicy';
import Refundpolicy from './landing/pages/refundpolicy';

// Miscellaneous
import Testimonial from './landing/pages/Testimonials';
import Loader from './landing/components/Loader';
import Login from './landing/pages/Login';
import Signup from './landing/pages/Signup';
import Srikrishnaamenu from './landing/pages/Srikrishnaamenu';


const TrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname); // Track route changes
  }, [location]);

  return null;
};

const PageWrapper = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setLoading(true); // Show loader on route change
    const timer = setTimeout(() => {
      setLoading(false); // Hide loader after some delay
    }, 1000); // Adjust the delay if needed

    return () => clearTimeout(timer);
  }, [location]);

  return loading ? <Loader /> : children;
};

function App() {
  useEffect(() => {
    initGA(); // Initialize Google Analytics once
  }, []);

  return (
    <BrowserRouter>
      <TrackPageView />
      <PageWrapper>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/Nav" element={<Nav />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/Signup" element={<Signup />} />
          <Route path="/Srikrishnaamenu" element={<Srikrishnaamenu />} />
          
          <Route path="/Aboutus" element={<Aboutus />} />
          <Route path="/Countingsection" element={<Countingsection />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/Menu" element={<Menu />} />
          <Route path="/Grababitenow" element={<Grababitenow />} />
          <Route path="/Testimonials" element={<Testimonial />} />
          <Route path="/Blog" element={<Blog />} />
          <Route path="/Terms" element={<Terms />} />
          <Route path="/Privacypolicy" element={<Privacypolicy />} />
          <Route path="/Refundpolicy" element={<Refundpolicy />} />
          <Route path="/Contactusform" element={<Contactusform />} />
          <Route path="/Loader" element={<Loader />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </PageWrapper>
    </BrowserRouter>
  );
}

export default App;
